// typeId by type name
import { OKR_ELEMENT_ENTITY_KEYS } from '@/utils/entity-keys'

export const OBJECTIVE_TYPES = {
  PERSONAL: 1,
  GROUP: 2,
  COMPANY: 3,
  KR: 4,
  TASK: 5,
  WORK_ITEM: 6
}
export const TYPE_ID_NAMES = {
  [OBJECTIVE_TYPES.PERSONAL]: 'objective',
  [OBJECTIVE_TYPES.GROUP]: 'objective',
  [OBJECTIVE_TYPES.COMPANY]: 'objective',
  [OBJECTIVE_TYPES.KR]: 'kr',
  [OBJECTIVE_TYPES.TASK]: 'task',
  [OBJECTIVE_TYPES.WORK_ITEM]: 'work-item'
}

const { TYPE_ID } = OKR_ELEMENT_ENTITY_KEYS

export const FAKE_OBJECTIVE_TYPES = {
  NO_NESTED_TASKS_FAKE_ROW: 'umc82rgyi'
}
export const isKR = objective => {
  return objective[TYPE_ID] === OBJECTIVE_TYPES.KR
}

export const objectiveIsJiraTask = objective => {
  return objective[TYPE_ID] === OBJECTIVE_TYPES.TASK
}

export const isWorkItem = okrElement => okrElement[TYPE_ID] === OBJECTIVE_TYPES.WORK_ITEM

export const isJiraIssueOrWorkItem = objective =>
  objectiveIsJiraTask(objective) || isWorkItem(objective)

export const isObjective = objective => {
  return (
    [OBJECTIVE_TYPES.PERSONAL, OBJECTIVE_TYPES.GROUP, OBJECTIVE_TYPES.COMPANY].includes(
      objective[TYPE_ID]
    ) &&
    !isKR(objective) &&
    !objectiveIsJiraTask(objective) &&
    !isWorkItem(objective)
  )
}

export const isKrOrObjective = objective => isKR(objective) || isObjective(objective)
